import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      PERSONAL_INFORMATION: "Personlig informasjon",
      CANCEL_BUTTON_TEXT: "Avbryt",
      SUBMIT_BUTTON_TEXT: "Lagre endring",
      FIRST_NAME_FORM_LABEL: "Fornavn",
      LAST_NAME_FORM_LABEL: "Etternavn",
      EMAIL_FORM_LABEL: "E-post adresse",
      TELEPHONE_FORM_LABEL: "Telefonnummer",

      REQUIRED_FIELD: "Dette felt er påkrævet",
      EMAIL_IN_USE: "E-mailen er allerede i brug",
      CAN_ONLY_CONTAIN_NUMBERS: "Kan kun indeholde tal",
      MUST_BE_EXACTLY_DIGITS: "Skal være nøjagtigt 8 cifre",
      TELEPHONE_NUMBER_ALREADY_IN_USE: "Telefonnummeret er allerede i bruk",
      MUST_BE_VALID_EMAIL: "Skal være en gyldig e-mail",
    },
    dk: {
      PERSONAL_INFORMATION: "Personlig information",
      CANCEL_BUTTON_TEXT: "Annuller",
      SUBMIT_BUTTON_TEXT: "Gem ændring",
      FIRST_NAME_FORM_LABEL: "Fornavn",
      LAST_NAME_FORM_LABEL: "Efternavn",
      EMAIL_FORM_LABEL: "E-mail",
      TELEPHONE_FORM_LABEL: "Mobil",

      REQUIRED_FIELD: "Dette felt er obligatorisk",
      EMAIL_IN_USE: "Denne e-mail er allerede i brug",
      CAN_ONLY_CONTAIN_NUMBERS: "Dette felt må kun indeholde tal”",
      MUST_BE_EXACTLY_DIGITS: "Skal indeholde nøjagtigt 8 cifre",
      TELEPHONE_NUMBER_ALREADY_IN_USE: "Telefonnummeret er allerede i brug",
      MUST_BE_VALID_EMAIL: "Skal være en gyldig e-mail",
    },
    se: {
      PERSONAL_INFORMATION: "Personuppgifter",
      CANCEL_BUTTON_TEXT: "Avbryt",
      SUBMIT_BUTTON_TEXT: "Spara ändring",
      FIRST_NAME_FORM_LABEL: "Förnamn",
      LAST_NAME_FORM_LABEL: "Efternamn",
      EMAIL_FORM_LABEL: "E-postadress",
      TELEPHONE_FORM_LABEL: "Mobilnummer",

      REQUIRED_FIELD: "Detta fält är obligatoriskt",
      EMAIL_IN_USE: "E-mailen används redan",
      CAN_ONLY_CONTAIN_NUMBERS: "Kan endast innehålla nummer",
      MUST_BE_EXACTLY_DIGITS: "Måste vara exakt 10 tecken",
      TELEPHONE_NUMBER_ALREADY_IN_USE: "Telefonnumret används redan",
      MUST_BE_VALID_EMAIL: "Måste vara en giltig emailadress",
    },
  } as const
)[language];
